import type { SVGProps } from 'react';
const SvgArrowCircleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="arrow-circle-left_svg__svg-inline--fa arrow-circle-left_svg__fa-arrow-circle-left arrow-circle-left_svg__fa-w-16"
    data-icon="arrow-circle-left"
    data-prefix="fal"
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      fill="currentColor"
      d="M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248M256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216m-12.5-92.5-115.1-115c-4.7-4.7-4.7-12.3 0-17l115.1-115c4.7-4.7 12.3-4.7 17 0l6.9 6.9c4.7 4.7 4.7 12.5-.2 17.1L181.7 239H372c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12H181.7l85.6 82.5c4.8 4.7 4.9 12.4.2 17.1l-6.9 6.9c-4.8 4.7-12.4 4.7-17.1 0"
    />
  </svg>
);
export default SvgArrowCircleLeft;
